<template>
  <app-industry-item-template :itemTitle="'Visa'" :routeName="'Contact'">

    <p><strong>Who is Visa?</strong></p>

    <p>
      Visa is the world leader in digital payments and the largest global payment network.<br><br>

      <strong>The business objective:</strong><br><br>

      Enable Visa clients in banking and beyond to benefit from a state-of-the-art SaaS loyalty platform when using 
      and issuing Visa products. Being able to seamlessly add personalized services to cardholders is a key business objective.
    </p>

    <img src="@/assets/images/cases/visa.jpg" alt="Visa Image">

    <br>
    <br>

    <p class="no-margin">
      <strong>How Visa did it - with our help</strong><br><br>

      Based on client requests Visa designed and scoped a SaaS loyalty platform solution and subsequently selected 
      LoyalTfacts&reg;, the market leading platform from Loyal Solutions, as the core engine for Visas`s new VMLS product.
      <a href="https://www.youtube.com/watch?v=UHpeJU2glVQ" target="_blank" rel="noopener">Learn more</a>
    </p>

  </app-industry-item-template>
</template>

<script>
  import AppIndustryItemTemplate from '@/components/layout/templates/content/AppContentTemplateIndustryItem';

  export default {
      name: 'CaseVisa',

      components: {
        AppIndustryItemTemplate,
      },
  }
</script>
